'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { getENV } from '../../../utils';
const SDK_LOAD_TIMEOUT_MS = 10_000;
type FormState = 'loading' | 'ready' | 'error';
type UseMedalliaFormParams = {
  isActive?: boolean;
};
export function useMedalliaForm(t0) {
  const $ = _c(12);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive: t2
  } = t1;
  const isActive = t2 === undefined ? true : t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getENV();
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    NEXT_PUBLIC_MEDALLIA_FORM_ID_US,
    NEXT_PUBLIC_MEDALLIA_FORM_ID_CA,
    NEXT_PUBLIC_LOCALE
  } = t3;
  const isCA = NEXT_PUBLIC_LOCALE === "en-CA";
  const formId = isCA ? NEXT_PUBLIC_MEDALLIA_FORM_ID_CA : NEXT_PUBLIC_MEDALLIA_FORM_ID_US;
  const [formState, setFormState] = useState("loading");
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (!window.KAMPYLE_ONSITE_SDK) {
        setFormState("error");
        return;
      }
      const loadedForm = window.KAMPYLE_ONSITE_SDK.loadForm(formId);
      setFormState(loadedForm ? "ready" : "error");
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const loadFeedbackForm = t4;
  let t5;
  let t6;
  if ($[4] !== isActive) {
    t5 = () => {
      if (!isActive) {
        return;
      }
      if (window.KAMPYLE_ONSITE_SDK) {
        loadFeedbackForm();
        return;
      }
      const handleSDKReady = () => {
        clearTimeout(timeoutId);
        loadFeedbackForm();
      };
      const handleSDKTimeout = () => {
        window.removeEventListener("neb_OnsiteLoaded", handleSDKReady);
        setFormState("error");
      };
      const timeoutId = setTimeout(handleSDKTimeout, SDK_LOAD_TIMEOUT_MS);
      window.addEventListener("neb_OnsiteLoaded", handleSDKReady, {
        once: true
      });
      return () => {
        window.removeEventListener("neb_OnsiteLoaded", handleSDKReady);
        clearTimeout(timeoutId);
      };
    };
    t6 = [isActive, formId];
    $[4] = isActive;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] !== isActive) {
    t7 = () => {
      if (!isActive) {
        return;
      }
      if (!window.KAMPYLE_ONSITE_SDK) {
        setFormState("error");
        return;
      }
      const openedForm = window.KAMPYLE_ONSITE_SDK.showForm(formId);
      if (!openedForm) {
        setFormState("error");
      }
    };
    $[7] = isActive;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const onOpen = t7;
  let t8;
  if ($[9] !== formState || $[10] !== onOpen) {
    t8 = {
      formState,
      onOpen
    };
    $[9] = formState;
    $[10] = onOpen;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}